export default "__VITE_ASSET__Bn9gxKj4__"